import { createReducer, on } from '@ngrx/store';
import { GlobalActions } from './global.actions';
import { GlobalState } from '@core/models/types/store.model';

const initialState: GlobalState = {
  isLoading: false,
};

export const globalReducer = createReducer(
  initialState,
  on(GlobalActions.setLoading, (state, data) => ({
    ...state,
    isLoading: data.isLoading,
  })),

  on(GlobalActions.setRedirectUrlLoginSuccess, (state, data) => ({
    ...state,
    redirectUrlLoginSuccess: data.url
  })),
  on(GlobalActions.clearRedirectUrlLoginSuccess, (state, data) => ({
    ...state,
    redirectUrlLoginSuccess: undefined
  })),
);
